export default __webpack_public_path__ + "static/media/error.66cbde6f.svg";